module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAASdJREFUKBV9kk9qwkAYxTOTRQ7QFukJBAt1mU0Q0RuIeEbpwhPULkI2gWzsQhCPIG4DWXTie2Fm+JKamYVx5nu/9735o/I830dRNEmSZJum6R3/g6Msy5emaQ4Q3TR+3tu2XWLhh4UQWVXVK3XQL6B70+i4UUqdsPAZMqBxXddH6qjvOHayUViYo/CLwkpuwdbZ0YFr1pWLOWYwBpLzMCdDA631zhjzNexILUcP5sLAwADUdo9dVGrc+AezUBTFFB3PFjRIMMuy7OIg9+VV9QY726is/dGAc673hJj0YBvZn2ocxx+ha/TwEMR1rRmVX2FwlAk62ILyAfjD4X0KgzkekjdQAuQD4cvxoNzjM52G0wGHEgRp8iTBnrFv6JiPdZTdhcE31q8PatMaWY1IcVMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/search/close.png
// module id = IWYZ
// module chunks = 2